/**
 * Bootstrap Entry Point
 *
 * This file is the actual entry point for the Wilson application.
 * It uses dynamic import to ensure the MUI ClassNameGenerator is configured
 * BEFORE any MUI components are loaded (avoiding ES module hoisting issues).
 *
 * Load order:
 * 1. dpl/config - Configures MUI class name prefix (Wilson-*)
 * 2. index.ts - Main application (loaded dynamically after config completes)
 *
 * Styles and tests select MUI elements by their Wilson-Mui* class names, so the prefix
 * must be set first.
 */

// Configure MUI class names first - this is the ONLY static import
// Uses centralized config from DPL so all Wilson apps use the same prefix
import 'dpl/config'

// Dynamically import the main app AFTER config is complete
// Dynamic import ensures no MUI code is loaded until after ClassNameGenerator is configured
import('./index')
